export default __webpack_public_path__ + "static/media/cardOverlay.1cf71f4b.svg";